import { makeStyles } from "@material-ui/core";

const useStyles = makeStyles((theme) => ({
  paper: {
    width: 500,
  },
  title: {
    textTransform: "capitalize",
  },
  textareaInput: {
    // !important needed because of https://github.com/visualization-suite/hvs_web/commit/755c0bf101b78b9038c75bfa23598ad6cc32d894#diff-61c28cd2cfcfd2fca70d1e3b7fcf909dd0bb7c1b3fe1c3cdc94444221f49f017R208
    resize: "none !important" as "none",
    overflow: "scroll",
  },
  margin: {
    marginBottom: theme.hv.spacing.md,
  },
  input: {
    height: 86,
  },
  textarea: {
    height: 100,
  },
  banner: {
    position: "absolute",
    top: theme.hv.spacing.xs,
    left: theme.hv.spacing.xs,
    right: theme.hv.spacing.xs,

    minWidth: 0,
    transform: "none",
  },
}));

export default useStyles;
